import { Routes } from '@angular/router';

import { STUDENTS_ROUTES } from '../students/ui/students.routes';

export const CLASSES_MANAGEMENT_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./classes-management.component').then((c) => c.ClassesManagementComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'students',
      },
      {
        path: 'students',
        children: STUDENTS_ROUTES,
      },

      {
        path: 'communications',
        loadComponent: () => import('../students/ui/communications/communications.component').then((c) => c.CommunicationsComponent),
        data: {
          breadcrumbs: [{ label: 'Gestion des cours', routerLink: '/admin/classes' }, { label: 'Communiquer aux étudiants' }],
        },
      },
      {
        path: 'planning',
        loadComponent: () => import('../planning/ui/planning.component').then((c) => c.PlanningComponent),
        data: {
          breadcrumbs: [{ label: 'Gestion des cours', routerLink: '/admin/classes' }, { label: 'Planning des cours' }],
        },
      },
    ],
  },
];
